import React, { FunctionComponent, useEffect, useRef, useState, } from "react";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
// import styles from "../../BulkEditModal/BulkEditModal.module.css";
import styles from "../../../src/Components/Modals/BulkEditModal/BulkEditModal.module.css";
import "./AuditLog.css"
import Loading from "../../Components/Loading/Loading";
import Backdrop from "../../Components/Backdrop/Backdrop";
import { motion } from "framer-motion";
import { IoIosClose } from "react-icons/io";
import Label from "../../Components/Label";
import TextInput from "../../Components/TextInput/TextInput";
import { themeColors } from "../../Components/theme";
import OtpInput from 'react-otp-input';
import classNames from "classnames";
import Import from "../../Components/Import/Import";
import axios from "axios";
import { url } from "../../Values/constants";
import { CSVLink } from "react-csv";
import axiosHandler from "../../Services/axiosHandler";

type props = {
  close?: () => void;
  open?: boolean;
  theme?: any;
  user?:any;
  setIsOtpVerified?:any;
  setAuditLog?:any;
  onExport?:any;
  selectedRows?: any[];
  panel?:any;
  organizationData?:any;
  operationType?:any;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const PopUpBox: FunctionComponent<props> = ({
  close,
  open,
  theme,
  user,
  setIsOtpVerified,
  setAuditLog,
  onExport,
  selectedRows,
  panel,
  organizationData,
  operationType
}) => {
  const dateRef: any = useRef();
  const [load, setLoad] = useState(false);
  const [otp, setOtp] = useState('');
  const [feilds, setFields] = useState([]);
  const csvLink: any = useRef();

  const dispatcher = useDispatch();
  useEffect(() => {
    // setFields(onExport && onExport());
    if(operationType === 'delete'){
      return;
    }
    else{
      const setFieldsData = async () => {
        let data = await onExport();
        setFields(data);
      }
      setFieldsData()
    }
    // eslint-disable-next-line
  }, []);
  const SaveData = async () => {
      try {
        let res = await axiosHandler.post(url+'/auditLogs/createExportLogs', {
        uid:user.uid?user.uid:"",
        user_email:user.user_email?user.user_email:"",
        user_first_name:user.user_first_name?user.user_first_name:"",
        user_last_name:user.user_last_name?user.user_last_name:"",
        total_count:selectedRows?.length?selectedRows?.length:"",
        type:panel?panel:"",
        organization_id:user.organization_id?user.organization_id:"",
        operation_type:"Export",
        description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} exported ${selectedRows?.length?selectedRows?.length:""} records from ${panel?panel:""} panel.`
        })
        // console.log("Export Log Saved Successfully");
        // dispatcher(
        //   showSnackbarAction(
        //     res.data.message,
        //     'success'
        //   )
        // );
      } catch (error) {
        // dispatcher(
        //   showSnackbarAction(
        //     "OTP Verification Failed ! Please try again",
        //     'error'
        //   )
        // );
        // console.log(error,"Export Log Couldn't Be Saved");
      }
  }
  const onResend = async (e:any) => {
    e.preventDefault();
    try {
      let res = await axiosHandler.post(url+'/otpVerification/resendOtp', {
        uid:user.uid?user.uid:"",
        user_email:user.user_email?user.user_email:"",
        user_first_name:user.user_first_name?user.user_first_name:"",
        user_last_name:user.user_last_name?user.user_last_name:"",
        otp_mail:organizationData.otp_verification_mail ? organizationData.otp_verification_mail : "",
        data_count:selectedRows?.length?selectedRows?.length:"",
        type:panel?panel:"",
        // operationType:"delete"
      })
      dispatcher(
        showSnackbarAction(
          res.data.message,
          'success'
        )
      );
    } catch (error) {
      dispatcher(
        showSnackbarAction(
          "OTP Not Sent ! Please Try Again",
          'error'
        )
      );
    }
  };
  const onVerify = async (e:any) => {
    e.preventDefault();
    try {
      let res = await axiosHandler.post(url+'/otpVerification/verifyOtp', {
        uid:user.uid,
        otp:otp
      })
      dispatcher(
        showSnackbarAction(
          res.data.message,
          'success'
        )
      );
      if(operationType === 'delete'){
        setIsOtpVerified(true);
      }
      else{
        csvLink.current.link.click();
        SaveData()
        setIsOtpVerified(true);
        setAuditLog(false);
      }
    } catch (error) {
      dispatcher(
        showSnackbarAction(
          "OTP Verification Failed ! Please try again",
          'error'
        )
      );
      setIsOtpVerified(false)
    }
  };
  const customStyles = {
    content: {
      backgroundColor: theme ? themeColors.dropdownBackgroundColor : themeColors.dropdownBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark
    },
  };
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <>
      {load === true && <Loading />}
      {open && <Backdrop>
        <motion.div
          key="modal"
          className="card p-4 shadow rounded"
          style={{
            position: "absolute", minWidth: "400px",
            ...containerStyles
          }}
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <div className={styles.firstDiv}>
            <h5
            >
              OTP Verification
            </h5>
            <div className={styles.cross} onClick={close}>
              <IoIosClose size={35} color={"#808080"} />
            </div>
          </div>
          <div className={styles.line}></div>

          <div
            className={styles.divide}
            style={{ marginTop: "2rem", width: "100%" }}
          >
            <p style={{color:"#279ea0"}}><b>OTP has been sent to {organizationData.otp_verification_mail ? organizationData.otp_verification_mail : ""}</b></p>
            {/* <h6>Enter OTP Code</h6> */}
            <form action="#">
              <div className="input-field" style={{display: "flex",flexDirection: "column",alignItems: "center",justifyContent: "center"}}>
              <h6>Enter OTP Code</h6>
                <OtpInput
                  value={otp}
                  inputStyle={{ height: "45px", width: "42px", borderRadius: "6px", outline: "none", fontSize: "1.125rem", border: "1px solid grey", boxShadow: " 0 1px 0 rgba(0, 0, 0, 0.1)" }}
                  containerStyle={{ columnGap: "10px", flexDirection: "row" }}
                  onChange={setOtp}
                  numInputs={4}
                  // renderSeparator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                />
              </div>
              <br />
              <button onClick={onVerify} style={{marginTop:"25px",width: "100%",color: "#fff",fontSize: "1rem", border: "none"
              ,padding: "9px 0",cursor: "pointer",borderRadius: "6px",background: "#279ea0",
              transition: "all 0.2s ease",pointerEvents:"auto"}}>Verify OTP
              </button>
              <button onClick={onResend} style={{marginTop:"25px",width: "100%",color: "#fff",fontSize: "1rem", border: "none"
              ,padding: "9px 0",cursor: "pointer",borderRadius: "6px",background: "#279ea0",
              transition: "all 0.2s ease",pointerEvents:"auto"}}>Resend OTP</button>
            </form>
            <br /><br />
          </div>
        </motion.div>
      </Backdrop>}
      <CSVLink
              data={feilds}
              filename={"data.csv"}
              className={styles.importText}
              ref={csvLink}
              target="_blank"
            />
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    organizationData: state.organization.organizationData,
  };
};

export default connect(mapStateToProps)(PopUpBox);